
/*** utils for table footer ****/
export const createInitialFooter = (columns, footerColums) => {
    let spanCount = 0;
    let answerArr = [];
    const specialNum = columns.filter((item) => footerColums.includes(item.label) && item.visibility).length;
    let checkCount = 0;
    let i = 0
    const cols = columns.filter(el => el.visibility);
    const check = (item) => {
        if (footerColums.includes(item)) {
            if (spanCount !== 0) {
                answerArr.push({
                    label: "",
                    colSpan: spanCount,
                    value: ""
                })
            }
            checkCount += 1;
            return true;
        } else {
            spanCount += 1;
            return false;
        }
    }
    for (const item of cols) {
        i += 1;
        if (checkCount < specialNum) {
            const con = check(item.label);
            if (con) {
                answerArr.push({
                    label: item.label,
                    colSpan: 1,
                    value: 0
                })
                spanCount = 0
            }
        } else {
            if (item.visibility) spanCount += 1;
            if (i === cols.length) {
                answerArr.push({
                    label: "",
                    colSpan: spanCount,
                    value: ""
                })
                spanCount = 0
            }
        }

    }
    return answerArr;
}

export const footerCalculation = (footer, data, arr) => {
    let ans = [...footer];
    let obj = arr.reduce((acc, day) => {
        acc[day] = 0;
        return acc;
    }, {});


    // Calculate sums for each day
    data.forEach(item => {
        arr.forEach(el => {
            obj[el] += Number(item[el]) || 0;
        });
    });

    ans.forEach(item => {
        if (arr.includes(item.label)) {
            item.value = obj[item.label];
        }
    });

    return ans;
}

